import React, { useState, useEffect } from 'react'
import { API_BASE } from '../supabaseClient'

export default function Dashboard({ session }) {
  const [stats, setStats] = useState({ total: 0, validated: 0, pending: 0 })
  const [recentValidations, setRecentValidations] = useState([])

  useEffect(() => {
    fetchReviewQueue()
  }, [])

  const fetchReviewQueue = async () => {
    try {
      const token = session?.access_token
      const headers = token ? { Authorization: `Bearer ${token}` } : {}

      const res = await fetch(`${API_BASE}/v1/validation/review-queue?status=pending`, { headers })
      const data = await res.json()
      setStats(prev => ({ ...prev, pending: data.total || 0 }))
    } catch (err) {
      console.error('Failed to fetch stats:', err)
    }
  }

  const downloadAuditPackage = (validationId) => {
    window.open(`${API_BASE}/v1/audit/${validationId}.zip`, '_blank')
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <p className="text-sm text-gray-500">Pending Reviews</p>
          <p className="text-3xl font-bold text-yellow-600">{stats.pending}</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <p className="text-sm text-gray-500">Auto-Validated</p>
          <p className="text-3xl font-bold text-green-600">{stats.validated}</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <p className="text-sm text-gray-500">Total Validations</p>
          <p className="text-3xl font-bold text-indigo-600">{stats.total}</p>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border">
        <div className="px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">Recent Validations</h2>
        </div>
        <div className="p-6">
          {recentValidations.length === 0 ? (
            <p className="text-gray-500 text-center py-8">
              No validations yet. Submit one from the Validate page.
            </p>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 border-b">
                  <th className="pb-2">ID</th>
                  <th className="pb-2">Type</th>
                  <th className="pb-2">Status</th>
                  <th className="pb-2">Confidence</th>
                  <th className="pb-2">Audit</th>
                </tr>
              </thead>
              <tbody>
                {recentValidations.map(v => (
                  <tr key={v.validation_id} className="border-b last:border-0">
                    <td className="py-2 font-mono text-xs">{v.validation_id?.slice(0, 8)}...</td>
                    <td className="py-2">{v.input_type}</td>
                    <td className="py-2">
                      <span className={`px-2 py-1 rounded text-xs ${
                        v.status === 'validated' ? 'bg-green-100 text-green-700' :
                        v.status === 'human_review_required' ? 'bg-yellow-100 text-yellow-700' :
                        'bg-red-100 text-red-700'
                      }`}>
                        {v.status}
                      </span>
                    </td>
                    <td className="py-2">{v.ready_signal_output?.confidence_score?.toFixed(2)}</td>
                    <td className="py-2">
                      {v.audit_ready && (
                        <button
                          onClick={() => downloadAuditPackage(v.validation_id)}
                          className="text-indigo-600 hover:text-indigo-800 text-xs"
                        >
                          Download ZIP
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}
